import * as React from "react";
import ConnectedFormControl from "../../FormControl/FormControl/FormControl.js";
import { isTextWithApostrophe } from "../../Util/Util/validations.js";
const City = ({
  label,
  errorMessage,
  validations = [isTextWithApostrophe],
  ...rest
}) => /* @__PURE__ */ React.createElement(
  ConnectedFormControl,
  {
    ...ConnectedFormControl.defaultProps,
    id: "city",
    "data-t": "city",
    type: "text",
    label,
    errorMessage,
    validations,
    ...rest
  }
);
export {
  City as default
};
//# sourceMappingURL=City.js.map
